import Main from "./pages/Main";
import LoginPage from "./pages/Login";
import RegisterPage from "./pages/Register";
import ForgetPage from "./pages/Forget";
import PanelPage from "./pages/Info";
import Serverspage from "./pages/Servers";
import ResetPassword from "./pages/ResetPassword";
import CheckToken from "./pages/CheckToken";
import Myservers from "./pages/Myservers";
import Withdraw from "./pages/Withdraw";
import Deposit from "./pages/Deposit";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Paycolife from "./pages/PaycolifePage";
import Serverconfig from "./pages/Serverconfig";
import ScrollToTop from "./helper/ScrollToTop";
import NotFoundPage from "./pages/NotFoundPage";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./Context/AuthContext";

export default function App() {
  const cookieExist = localStorage.getItem("token")?.length > 20 ? true : false;

  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop>
          <Routes>
            <Route path="/" exact element={<Main />} />
            <Route path="/login" exact element={cookieExist ? <Main /> : <LoginPage />} />
            <Route path="/register" exact element={cookieExist ? <Main /> : <RegisterPage />}>
              <Route path=":refID" element={cookieExist ? <Main /> : <RegisterPage />} />
            </Route>
            <Route path="/forget" exact element={cookieExist ? <Main /> : <ForgetPage />} />
            <Route path="/Forget/:forgetToken" exact element={cookieExist ? <Main /> : <ResetPassword />} />
            <Route path="/panel" exact element={cookieExist ? <PanelPage /> : <LoginPage />} />
            <Route path="/servers" exact element={cookieExist ? <Serverspage /> : <LoginPage />} />
            <Route path="/myservers" exact element={cookieExist ? <Myservers /> : <LoginPage />} />
            <Route path="/withdraw" exact element={cookieExist ? <Withdraw /> : <LoginPage />} />
            <Route path="/deposit" exact element={cookieExist ? <Deposit /> : <LoginPage />} />
            <Route path="/pagenotfound" exact element={<NotFoundPage />} />
            <Route path="/contact" exact element={<Contact />} />
            <Route path="/about" exact element={<About />} />
            <Route path="/paycolife" exact element={<Paycolife />} />
            <Route path="/server/:serverID" exact element={cookieExist ? <Serverconfig /> : <LoginPage />} />
            <Route path="/users/:userID/verify/:tokenID" exact element={<CheckToken />} />
          </Routes>
        </ScrollToTop>
      </AuthProvider>
    </BrowserRouter>
  );
}
